import { useCallback, useEffect, useState } from "react";
import { PopService } from "../services/PopService";
import { GenieAcsService } from "../services/GenieAcsService";
import { SubscriptionPlanService } from "../services/SubscriptionPlanService";
import { CompanyService } from "../services/CompanyService";

export const useHookCompanyByCompany = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await CompanyService.showByCompany()
            setData(res.data.data);
        }catch(err){
            setError(err);
            // throw err;
        }finally{
            setLoading(false);
        }
    }, []);

    useEffect(()=>{
        getData();
    },[getData]);

    return {
        data,
        loading,
        error,
        
        refreshData: () => getData(),
    }
}